import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutes } from '@constants';

const routes: Routes = [
  {
    path: AppRoutes.DEFAULT_EMPTY,
    redirectTo: AppRoutes.DEFAULT_EMPTY,
    pathMatch: 'full',
  },
  {
    path: AppRoutes.DEFAULT_EMPTY,
    loadChildren: () =>
      import('./pages/home/home.module').then(m => m.HomeModule),
  },
  {
    path: AppRoutes.COMMERTIAL,
    loadChildren: () =>
      import('./pages/commercial-executive/commercial-executive.module').then(
        m => m.CommercialExecutiveModule,
      ),
  },
  {
    path: AppRoutes.DASHBOARD,
    loadChildren: () =>
      import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule),
  },
  { path: '**', redirectTo: AppRoutes.LOGIN },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
